export default __webpack_public_path__ + "static/media/Icons_Tick icon.d9895264.svg";